import * as React from "react";
import { Space } from "../space";
import { ButtonProps } from "./button";
import { omitNullOrUndefined } from "../../utils/object";
import { StyleProps } from "../../utils/types";

const ButtonGroupContext = React.createContext<ButtonGroupProps>({});

type ButtonGroupProps = Pick<
  ButtonProps,
  | "color"
  | "variant"
  | "size"
  | "radius"
  | "idleColor"
  | "idleVariant"
  | "activeColor"
  | "activeVariant"
  | "isToggle"
> &
  StyleProps<"wrapper"> & {
    label?: string;
  };

export function ButtonGroup({
  color,
  variant,
  size,
  compact,
  radius,
  gap,
  children,
  idleColor,
  activeColor,
  idleVariant,
  activeVariant,
  isToggle,
  className,
  classNames,
  style,
  styles,
}: ButtonGroupProps & React.ComponentProps<typeof Space>) {
  const cleanProps = omitNullOrUndefined({
    color,
    variant,
    size,
    radius,
    idleColor,
    activeColor,
    idleVariant,
    activeVariant,
    isToggle,
  });

  return (
    <ButtonGroupContext.Provider value={cleanProps}>
      <Space
        className={className}
        classNames={classNames}
        style={style}
        styles={styles}
        gap={gap}
        compact={compact}
      >
        {children}
      </Space>
    </ButtonGroupContext.Provider>
  );
}

export function useButtonGroup() {
  return React.useContext(ButtonGroupContext);
}
